<script>
import { get } from "lodash";

export default {
  props: {
    absolute: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      title: null,
      breadcrumb: []
    };
  },
  methods: {
    applyContextToUrl: Fandom.applyContextToUrl
  },
  computed: {
    current() {
      if (globalState.pageModel.seo && globalState.pageModel.seo.title) {
        return globalState.pageModel.seo.title.split('|')[0];
      } else {
        const mainContentName = globalState.pageModel.main_content_name;
        return globalState.pageModel.name_to_content[mainContentName].title;
      }
    }
  },
  mounted() {
    for (const content of globalState.pageModel.breadcrumb) {
      const title = get(content, ["seo", "title"], content.title);
      if (Fandom.exists(title)) {
        this.breadcrumb.push({ title: title, url: content.slug });
      }
    }
  }
};
</script>

<template>
  <div class="d-none d-md-block position-relative w-100" breadcrumb-component>
    <div class="breadcrumb-container p-4" :class="{'position-absolute text-white': absolute}">
      <div class="container px-4">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb m-0 p-0">
            <li class="breadcrumb-item"><a :href="applyContextToUrl('/')">Home</a></li>
            <li v-for="(b, ib) in breadcrumb" class="breadcrumb-item text-uppercase" aria-current="page" :key="`breadcrumb-${ib}`">
              <template v-if="b.url"><a v-if="b.url" :href="applyContextToUrl(b.url)">{{b.title}}</a></template>
              <template v-else><span>{{b.title}}</span></template>
            </li>
            <li class="breadcrumb-item font-weight-bold" aria-current="page">{{current}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[breadcrumb-component] {

  z-index: 1;

  .breadcrumb-container.position-absolute {
    top: 0;
    left: 0;
    right: 0;
    background-image: linear-gradient(to top, rgba(238, 238, 238, 0), rgba(0, 0, 0, 0.4));

    .breadcrumb-item > a,
    .breadcrumb-item + .breadcrumb-item::before {
      color: $white;
    }
  }

  .breadcrumb-container:not(.position-absolute) {
    .breadcrumb-item > a,
    .breadcrumb-item + .breadcrumb-item::before {
      color: $black;
    }
  }

  .breadcrumb {
    background-color: transparent;
  }

  .breadcrumb-item {
    @include font-size(14px);
  }

  .breadcrumb-item + .breadcrumb-item::before {
    content: "›" !important;
    font-weight: normal;
  }

}
</style>